import {Inject, Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DateUtils} from '../date.utils';
import {IAppConfig} from '../../store/interfaces/IAppConfig';
import {APP_CONFIG} from '../../api/config/app.config';

@Pipe({
  name: 'dateFormatter'
})
export class DateFormatterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe, @Inject(APP_CONFIG) private appConfig: IAppConfig) {}

  transform(value: Date, dateType: string): string {
    const format = DateUtils.resolveCalendarDateFormat(this.appConfig);
    return this.datePipe.transform(value, format);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/pipe/date-formatter.pipe.ts